import { AnimatePresence, motion } from 'motion/react';

import { Box, Button, colors, SwitchGroup, u } from '@ui';

import { useGoalReportContext, periodOptions, lastSwingsOption } from '../../GoalReportContext';

import * as css from './GoalReportFilters.css';

export const GoalReportFilters = () => {
    const {
        updateFilters,
        uiFilters,
        filters,
        customRange,
        showFilters,

        setCustomRange,
        minDate,
        maxDate,
    } = useGoalReportContext();

    const { from, to } = customRange;
    const isPeriodInactive = !filters.period;
    const isCustomActive = filters.period === 'custom';

    return (
        <AnimatePresence initial={false}>
            {showFilters && (
                <motion.div
                    className={css.goalReportFilterRow}
                    initial={{ height: 0, opacity: 0, y: -8 }}
                    animate={{ height: 'auto', opacity: 1, y: 0 }}
                    exit={{ height: 0, opacity: 0, y: -8 }}
                    transition={{
                        duration: 0.2,
                        ease: 'easeOut',
                    }}
                    style={{ overflow: 'hidden' }}
                >
                    <Box
                        display="flex"
                        flexDirection={{ xs: 'column', lg: 'row' }}
                        flexWrap={'wrap'}
                        pb={u(2)}
                        className={css.goalReportFilters}
                    >
                        <fieldset className={css.buttonGroup}>
                            <legend className={css.buttonGroupLegend}>Time period</legend>
                            <SwitchGroup
                                value={uiFilters.period}
                                options={periodOptions}
                                isMuted={isPeriodInactive}
                                onClick={(activeKey) => updateFilters({ period: activeKey })}
                            />
                        </fieldset>
                        <Box display={'flex'} gap={u(2)} flexWrap="nowrap">
                            <fieldset className={css.buttonGroup}>
                                <legend className={css.buttonGroupLegend}>Start Date</legend>
                                <input
                                    type="date"
                                    style={{ color: isCustomActive ? colors.blue[500] : 'inherit' }}
                                    className={css.dateInputs}
                                    value={from ?? ''}
                                    min={minDate}
                                    max={to ?? ''}
                                    onChange={(e) => setCustomRange({ from: e.target.value || undefined })}
                                />
                            </fieldset>
                            <fieldset className={css.buttonGroup}>
                                <legend className={css.buttonGroupLegend}>End Date</legend>

                                <input
                                    style={{ color: isCustomActive ? colors.blue[500] : 'inherit' }}
                                    type="date"
                                    className={css.dateInputs}
                                    value={to ?? ''}
                                    min={from ?? ''}
                                    max={maxDate}
                                    onChange={(e) => setCustomRange({ to: e.target.value || undefined })}
                                />
                            </fieldset>
                        </Box>

                        <fieldset className={css.buttonGroup}>
                            <legend className={css.buttonGroupLegend}>Number of swings</legend>
                            <SwitchGroup
                                options={lastSwingsOption}
                                value={uiFilters.swings}
                                isMuted={!isPeriodInactive}
                                onClick={(activeKey) => updateFilters({ swings: activeKey })}
                            />
                        </fieldset>
                        <Box display="flex" justifyContent={{ md: 'flex-start' }} alignItems={'center'}>
                            <ResetFilterButton />
                        </Box>
                    </Box>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export function ResetFilterButton() {
    const { resetFilters } = useGoalReportContext();
    return (
        <Box height="min-content">
            <Button icon="close" size="small" variant="secondary" onClick={resetFilters}>
                reset filters
            </Button>
        </Box>
    );
}
